import { useEffect } from 'react';
import { analytics } from '@Helpers/analytics';
import { useConfigLoader } from '@App/ConfigLoader';
import * as Sentry from '@sentry/nextjs';

export const Analytics = () => {
  const { config } = useConfigLoader() || {};
  useEffect(() => {
    if (config?.FACEBOOK_PIXEL_ID || config?.GTM_CONTAINER_ID) {
      try {
        analytics({
          gtmContainerId: config?.GTM_CONTAINER_ID,
          pixelId: config?.FACEBOOK_PIXEL_ID,
        });
      } catch (error) {
        Sentry.captureMessage('Analytics component initialization failed', {
          level: 'warning',
          extra: {
            error,
            gtmContainerId: config?.GTM_CONTAINER_ID,
            pixelId: config?.FACEBOOK_PIXEL_ID,
          },
        });
      }
    }
  }, [config?.FACEBOOK_PIXEL_ID, config?.GTM_CONTAINER_ID]);

  return null;
};
